<!-- 报表下载 -->
<template>
  <div class="app-container">
    <div class="app-content">
      <el-card
        class="card-wrap"
        shadow="never"
      >
        <div class="main-content column-flex">
          <div class="search-form">
            <el-form label-width="90px">
              <el-row :gutter="15">
                <el-col :span="6">
                  <el-form-item :label="$t('text.kssj')">
                    <el-date-picker
                      v-model="starttime"
                      type="date"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('text.jssj')">
                    <el-date-picker
                      v-model="endtime"
                      type="date"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-button
                    icon="el-icon-video-play"
                    type="primary"
                    @click="handleQuery"
                  >{{ $t('button.yl') }}</el-button>
                  <el-button
                    icon="el-icon-download"
                    type="warning"
                    @click="handleExport"
                  >{{ $t('button.dc') }}</el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div v-if="showdata" class="table-wrap">
            <el-form style="margin:20px 30px">
              <el-row>
                <el-col :span="12">
                  <div>
                    <img :src="logo" alt="">
                    <p class="font">{{ title }}</p>
                  </div>
                </el-col>
                <el-col :span="12" class="same">
                  <el-row>
                    <el-col :span="18">
                      <span>Account Enquiries:</span>
                    </el-col>
                    <el-col :span="6">
                      <span>{{ accountTel }}</span>
                    </el-col>
                    <el-col>
                      <span>{{ accountTime }}</span>
                    </el-col>
                    <el-col :span="18">
                      <span>Faults:</span>
                    </el-col>
                    <el-col :span="6">
                      <span>{{ faultsTel }}</span>
                    </el-col>
                    <el-col>
                      <span>{{ faultsTime }}</span>
                    </el-col>
                    <el-col :span="18">
                      <span>Life-threatening emergenciec:</span>
                    </el-col>
                    <el-col :span="6">
                      <span>{{ emergencyTel }}</span>
                    </el-col>
                    <el-col>
                      <span>{{ emergencyTime }}</span>
                    </el-col>
                    <el-col>
                      <span>General-Enquiries:</span>
                    </el-col>
                    <el-col>
                      <span>{{ generalEmail }}</span>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col>
                  <el-col :span="12" style="padding-right:100px">
                    <div>
                      <span>
                        {{ userinfo1 }}
                      </span>
                    </div>
                    <div>
                      <span>
                        {{ userinfo2 }}
                      </span>
                    </div>
                    <div>
                      <span>
                        {{ useraddr1 }}
                      </span>
                    </div>
                    <div>
                      <span>
                        {{ useraddr2 }}
                      </span>
                    </div>
                  </el-col>
                  <el-col :span="12" style="margin-top:30px">
                    <el-col style="padding-bottom:20px;position: relative;">
                      <span class="line public">Account Details</span>
                    </el-col>
                    <el-col :span="12">
                      <span>Invoice Number</span>
                    </el-col>
                    <el-col :span="12">
                      <span>{{ invoiceNumber }}</span>
                      <!-- <span>18</span> -->
                    </el-col>
                    <el-col :span="12">
                      <span>Service Address</span>
                    </el-col>
                    <el-col :span="12">
                      <div> <span>{{ useraddr1 }} </span></div>
                      <div> <span>{{ useraddr2 }} </span></div>
                    </el-col>
                    <el-col :span="12">
                      <span>Issue Date</span>
                    </el-col>
                    <el-col :span="12">
                      <span>{{ issueDate }}</span>
                    </el-col>
                    <el-col :span="12">
                      <span>Billing Period</span>
                    </el-col>
                    <el-col :span="12">
                      <span>{{ billingPeriod }}</span>
                    </el-col>
                    <el-col :span="12">
                      <span class="public">Due Date</span>
                    </el-col>
                    <el-col :span="12">
                      <span class="public">{{ dueDate }}</span>
                    </el-col>
                    <el-col :span="12">
                      <span class="public">Amount Due</span>
                    </el-col>
                    <el-col :span="12">
                      <span class="public">${{ amountDue }}</span>
                    </el-col>
                  </el-col>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <div class="tabline public" style="position:relative;margin:30px 0">Details Chargs Breakdown</div>
                  <el-table :data="list.charges" border>
                    <el-table-column label="Meter ID" prop="sn" align="center" />
                    <el-table-column label="PREVIOUS READING" prop="previous" align="center" />
                    <el-table-column label="CURRENT READING" prop="current" align="center" />
                    <el-table-column label="KWH PRODUCED" prop="energy" align="center" />
                    <el-table-column label="PRICE" prop="price" align="center" />
                    <el-table-column label="TOTAL NEW CHARGES" prop="charges" align="center" />
                    <el-table-column label="GST" prop="gst" align="center" />
                    <el-table-column label="TOTAL (INC GST)" prop="totalGst" align="center" />
                  </el-table>
                </el-col>
              </el-row>
              <el-row>
                <el-col style="margin:30px 0">
                  <div style="position:relative" class="pay public">Payment Options</div>
                </el-col>
                <el-col>
                  <p>Phone Pay (Visa Or MasterCard*)</p>
                  <p>Call 08 6311 9906 to organise. Payments via Visa or MasterCard will incur</p>
                  <p>a processing fee of 1.5% (inc GST) of the total payment amount.</p>
                  <p>By Mail</p>
                  <p>Post this invoice with cheque payable to</p>
                  <p> Zeus Appollo Pty Ltd</p>
                  <p>PO Box 926, West Perth WA 6872</p>
                  <p>Electronic Funds Transfer (Bank Transfer)</p>
                  <p>Bank: NAB BSB: 086-082</p>
                  <p>Account Number:155 452 298</p>
                  <p>Account Name: Zeus Appollo Pty Ltd</p>
                  <p>Please use your invoice number as the payment description.</p>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { GetBillData, ExpBill } from '@/api/Meter'

export default {
  components: {},
  data () {
    return {
      fullLoading: null,
      starttime: '',
      endtime: '',
      list: [],
      logo: '',
      title: '',
      accountTel: '',
      accountTime: '',
      faultsTel: '',
      faultsTime: '',
      emergencyTel: '',
      emergencyTime: '',
      generalEmail: '',
      userinfo1: '',
      userinfo2: '',
      useraddr1: '',
      useraddr2: '',
      invoiceNumber: '',
      issueDate: '',
      billingPeriod: '',
      dueDate: '',
      amountDue: '',
      showdata: false
    }
  },
  computed: {

  },

  created () {

  },
  methods: {

    // 预览
    handleQuery () {
      GetBillData({
        startTime: this.starttime,
        endTime: this.endtime,
        orgId: this.$store.getters.station.id,
        dueDate: ''
      })
        .then((res) => {
          this.list = res.data
          this.logo = res.data.logo
          this.title = res.data.title
          this.accountTel = res.data.accountTel
          this.accountTime = res.data.accountTime
          this.faultsTel = res.data.faultsTel
          this.faultsTime = res.data.faultsTime
          this.emergencyTel = res.data.emergencyTel
          this.emergencyTime = res.data.emergencyTime
          this.generalEmail = res.data.generalEmail
          this.userinfo1 = res.data.userinfo1
          this.userinfo2 = res.data.userinfo2
          this.useraddr1 = res.data.useraddr1
          this.useraddr2 = res.data.useraddr2
          this.invoiceNumber = res.data.invoiceNumber
          this.issueDate = res.data.issueDate
          this.billingPeriod = res.data.billingPeriod
          this.dueDate = res.data.dueDate
          this.amountDue = res.data.amountDue
          this.showdata = true
        })
    },
    formatTime (row, column, cellValue) {
      return this.$parseTime(cellValue, 'dd-MM-yyyy hh:mm:ss')
    },
    // 导出
    handleExport () {
      this.fullLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      ExpBill({
        startTime: this.starttime,
        endTime: this.endtime,
        orgId: this.$store.getters.station.id,
        dueDate: ''
      })
        .then(res => {
          this.fullLoading.close()
          window.location.href = res.data
        })
        .catch(() => {
          this.fullLoading.close()
        })
    }
  },
}
</script>
<style lang='stylus' scoped>
.app-container {
  margin-right: 5px;
  padding: 10px;
  background-color: #F8F8F8;
}

.el-input + .el-input {
  margin-top: 0;
}
.search-form {
  height: 60px;
}

.table-wrap
    width: calc(100vw - 1000px);
    margin: 0 auto;
.line::before
  content: '';
  position: absolute;
  width calc(100% - 40px);
  height 2px;
  background-color: black;
  bottom 20px;
.tabline::before
  content: '';
  position: absolute;
  width calc(100%);
  height 2px;
  background-color: black;
  top 20px;
.el-table >>>th
  background-color: #D0CECE;
  color: #303133
.el-table >>>tr
  background-color: #E7E6E6;
.pay::before
  content: '';
  position: absolute;
  width calc(100%);
  height 2px;
  background-color: black;
  top 20px;
.font
    font-size: 30px;
    font-weight: bold;
    padding: 15px 0px 45px 85px;
.public
    font-weight bold
    font-size 18px

.report-main {
  .title {
    font-weight: bold;
    font-size: 16px;
    padding: 10px;
    text-align: center;
  }

  .el-card {
    border-radius: 0;

    & ::v-deep .el-card__header {
      height: 40px;
      padding: 0;
      line-height: 40px;
      text-indent: 1em;
      background-color: #5DADE2;
      color: #fff;
    }

    & ::v-deep .el-card__body {
      padding: 0;
    }

    section {
      height: 40px;
      border-bottom: solid 1px #EBEEF5;

      &:last-child {
        border: none;
      }

      span {
        display: inline-block;
        height: 100%;
        width: 300px
        padding-left: 10px
      }

      b {
        font-weight: normal;
        padding-right: 30px
        display: inline-block;
        height: 100%;
        line-height: 40px;
        text-align: center;
        vertical-align: middle;
      }

    }
  }
}
</style>
